import type { KgInsight } from '@api';
import { t } from 'i18next';
import type { SectionNavItem } from '../components/section-nav/SectionNav';

export const isKgInsightSectionVisible = (
  section: KgInsight['sections'][number]
) => {
  switch (section.type) {
    case 'graph':
      return section.data.cohorts.length > 0;
    case 'takeaway':
    case 'quotes':
    case 'details_grid':
    case 'geo':
      return section.data.cards.length > 0;
    default:
      return true;
  }
};

export const getKgInsightSectionNavItems = (
  category: KgInsight['category'],
  sections: KgInsight['sections']
): SectionNavItem[] =>
  sections.filter(isKgInsightSectionVisible).map(section => {
    if (section.type === 'details_grid') {
      return {
        id: section.type,
        label: t(`insights:catalystGeneration.details_grid.${category}.title`),
      };
    }

    if (section.type === 'takeaway') {
      return {
        id: section.type,
        label: t('insights:catalystGeneration.section_takeaway', {
          count: section.data.cards.length,
        }),
      };
    }

    return {
      id: section.type,
      label: t('insights:catalystGeneration.section', {
        context: section.type,
      }),
    };
  });
